import type { EulerKeyframe, ScaleKeyframe, Vector3Keyframe } from './utils'
import { arraysToVector3s, createAnimationClip } from './utils'

export const primaryTokenScales = [
    1.25, // stars
    1, // dollar sign
    1.75, // dollar sign
    0.75, // globe
]

export const secondaryTokenScales = [
    2, // dollar sign
    1.5, // stars
    2, // dollar sign
    1.5, // stars
]

export const itemDrift = 5

const { PI } = Math

// PHONE

const phoneScales: [ScaleKeyframe[], ScaleKeyframe[]] = [
    [
        // mobile
        { time: 0, value: 1.1 },
        { time: 0.25, value: 0.9 },
        { time: 0.45, value: 0.9 },
        { time: 0.55, value: 0.25 },
        { time: 1, value: 0.25 },
    ],
    [
        // desktop
        { time: 0, value: 1.3 },
        { time: 0.45, value: 1.3 },
        { time: 0.55, value: 0.25 },
        { time: 1, value: 0 },
    ],
]

const phonePositions: [Vector3Keyframe[], Vector3Keyframe[]] = [
    [
        // mobile
        { time: 0, value: [1, -2, -1] },
        { time: 0.2, value: [-0.75, -1.75, 0] },
        { time: 0.44, value: [-0.75, -1.75, 0] },
        { time: 0.52, value: [-1, -1.5, 0] },
        { time: 0.6, value: [-0.5, -1, -1] },
        { time: 1, value: [0, 0, -1] },
    ],
    [
        // desktop
        { time: 0, value: [0.25, -2.5, -1] },
        { time: 0.2, value: [-1, -2.5, 0] },
        { time: 0.44, value: [-0.75, -2.5, 0] },
        { time: 0.52, value: [-2, -1.75, 0] },
        { time: 0.6, value: [-0.5, -1, 0] },
        { time: 1, value: [-0.5, -1, 0] },
    ],
]

const phoneRotations: [EulerKeyframe[], EulerKeyframe[]] = [
    [
        // mobile
        { time: 0, value: [-PI / 10, PI / 5, PI / 8] },
        { time: 0.2, value: [-PI / 10, -PI / 10, -PI / 8] },
        { time: 0.44, value: [-PI / 8, -PI / 10, -PI / 8] },
        { time: 0.6, value: [PI / 10, PI, 0] },
        { time: 1, value: [PI / 10, PI, 0] },
    ],
    [
        // desktop
        { time: 0, value: [-PI / 10, PI / 5, PI / 8] },
        { time: 0.2, value: [-PI / 10, -PI / 8, -PI / 8] },
        { time: 0.44, value: [-PI / 8, -PI / 8, -PI / 8] },
        { time: 0.6, value: [PI / 10, PI, 0] },
        { time: 1, value: [PI / 10, PI, 0] },
    ],
]

export const phoneAnim = [
    createAnimationClip('phone', {
        // mobile
        scale: phoneScales[0],
        position: phonePositions[0],
        rotation: phoneRotations[0],
    }),
    createAnimationClip('phone', {
        // desktop
        scale: phoneScales[1],
        position: phonePositions[1],
        rotation: phoneRotations[1],
    }),
]

// CARD

const cardScales: [ScaleKeyframe[], ScaleKeyframe[]] = [
    [
        // mobile
        { time: 0, value: 0.7 },
        { time: 0.6, value: 0.9 },
        { time: 1, value: 0.9 },
    ],
    [
        // desktop
        { time: 0, value: 1 },
        { time: 0.4, value: 0.8 },
        { time: 0.7, value: 1.2 },
        { time: 1, value: 1.2 },
    ],
]

const cardPositions: [Vector3Keyframe[], Vector3Keyframe[]] = [
    [
        // mobile
        { time: 0, value: [0.75, 0.65, 3] },
        { time: 0.05, value: [-1, -0.5, 0] },
        { time: 0.25, value: [0.5, 0.5, -3] },
        { time: 0.425, value: [0.875, 1, -3] },
        { time: 0.475, value: [2.25, 0, 0.5] },
        { time: 0.525, value: [0.75, 0, 2] },
        { time: 0.75, value: [0.1, 0, 2.5] },
        { time: 1, value: [-0.1, 0, 2.5] },
    ],
    [
        // desktop
        { time: 0, value: [-1, -0.5, 3] },
        { time: 0.05, value: [-2.5, -1, -1] },
        { time: 0.25, value: [0.5, -0.5, -3] },
        { time: 0.425, value: [0.5, -0.5, -3] },
        { time: 0.475, value: [2, 0, 0] },
        { time: 0.525, value: [0.45, 0, 2.5] },
        { time: 0.75, value: [0, -0, 3] },
        { time: 1, value: [-0.2, -0.2, 2.5] },
    ],
]

const cardRotations: [EulerKeyframe[], EulerKeyframe[]] = [
    [
        // mobile
        { time: 0, value: [-PI / 12, -PI / 8, -0.6 * PI] },
        { time: 0.1, value: [-PI / 8, -PI * 0.75, -0.55 * PI] },
        { time: 0.45, value: [-PI / 8, -PI * 0.85, -0.35 * PI] },
        { time: 0.53, value: [-PI / 10, -PI * 0.95, 0.166 * PI] },
        { time: 1, value: [-PI / 9, -PI * 0.95, 0.333 * PI] },
    ],
    [
        // desktop
        { time: 0, value: [-PI / 12, -PI / 8, -0.6 * PI] },
        { time: 0.1, value: [-PI / 8, -PI * 0.75, -0.55 * PI] },
        { time: 0.45, value: [-PI / 8, -PI * 0.85, -0.65 * PI] },
        { time: 0.53, value: [-PI / 10, -PI * 0.95, 0.166 * PI] },
        { time: 1, value: [-PI / 9, -PI * 0.95, 0.333 * PI] },
    ],
]

export const cardAnim = [
    createAnimationClip('card', {
        // mobile
        scale: cardScales[0],
        position: cardPositions[0],
        rotation: cardRotations[0],
    }),
    createAnimationClip('card', {
        // desktop
        scale: cardScales[1],
        position: cardPositions[1],
        rotation: cardRotations[1],
    }),
]

// SECONDARY TOKENS
const TOKEN_PLANE_Z = 6.5
export const SWAY_PLANE_Z = TOKEN_PLANE_Z + 6
export const secondaryTokenPositions = [
    [
        // mobile
        [-0.45, 0.75, TOKEN_PLANE_Z],
        [0.4, -0.2, TOKEN_PLANE_Z],
        [-100.4, 0.62, TOKEN_PLANE_Z],
        [0.3, 0.7, TOKEN_PLANE_Z],
    ].map(arraysToVector3s),
    [
        // desktop
        [-0.75, 0.2, TOKEN_PLANE_Z], // section 1 hashtag
        [0.8, -0.3, TOKEN_PLANE_Z], // section 1 dollar sign
        [-1.1, 0.39, TOKEN_PLANE_Z], // section 2 dollar sign
        [1, 0, TOKEN_PLANE_Z], // section 2 stars
    ].map(arraysToVector3s),
]
